import { Routes, Route } from 'react-router-dom'
import { useState, useCallback } from 'react'
import { AnimatePresence } from 'framer-motion'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import PracticePage from './pages/PracticePage'
import { AnalysisData, UnitContext } from './types'

function App() {
  const [analysisData, setAnalysisData] = useState<AnalysisData | null>(null)
  const [unitContext, setUnitContext] = useState<UnitContext | null>(null)

  // 开始新练习时的回调
  const handleStartPractice = useCallback((data: AnalysisData, context: UnitContext | null) => {
    setAnalysisData(data)
    setUnitContext(context)
  }, [])

  // 清除练习上下文
  const handleClearContext = useCallback(() => {
    setUnitContext(null)
  }, [])

  return (
    <Layout>
      <AnimatePresence mode="wait">
        <Routes>
          <Route 
            path="/" 
            element={
              <HomePage 
                onAnalysisComplete={handleStartPractice}
              />
            } 
          />
          <Route 
            path="/practice" 
            element={
              <PracticePage 
                analysisData={analysisData}
                unitContext={unitContext}
                onUpdateUnitContext={setUnitContext}
                onClearContext={handleClearContext}
              />
            } 
          />
        </Routes>
      </AnimatePresence>
    </Layout>
  )
}

export default App

